export const companyInfoList = [
    {
        key: 'инн:',
        value: '7813642198',
    },
    {
        key: 'кпп:',
        value: '781601001',
    },
    {
        key: 'огрн:',
        value: '1207800001265',
    },
    {
        key: 'код отрасли по оквэд:',
        value: '62.01',
    },
    {
        key: 'адрес:',
        value: '192007, г. Санкт-Петербург, пр-кт Лиговский, д. 140, литер А, пом., комн.13-Н, 4',
        withGap: true,
    },
];
